import useLazyByProject from './useLazyByProject';
import { getAppConfig } from '../services/AppConfigService';

/**
 * The secrets each project of a workspace still has to set (the Configuration tab's "n to set", services/AppConfigService.js
 * getAppConfig), two projects at a time. Returns `{ entries, reload }` as `useLazyByProject`; a value is
 * `{ missing: [{ service, name }] }`.
 */
export default function useWorkspaceSecrets(projectIds, { enabled = true } = {}) {
  return useLazyByProject(projectIds, async(projectId) => {
    const answer = await getAppConfig(projectId);
    const missing = (answer?.services || []).flatMap((service) => (service.secretsMissing || []).map((name) => ({ service: service.name, name })));
    return { missing };
  }, { enabled, concurrency: 2 });
}
